import React, { useState, useEffect } from "react";
import { Typography, Box, useTheme, Button, Grid } from "@mui/material";
import { tokens } from "../../theme";
import "./Stylesheet.css";
import { useNavigate } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";
const Header = ({
  type,
  disabled,
  title,
  navigateionto,
  onClickTerm,
  startIcon,
  fontSize,
  borderRadius,
  width,
  className,
}) => {
  const theme = useTheme();
  const [screenWidth, setScreenWidth] = useState("");
  const colors = tokens(theme.palette.mode);
  let navigate = useNavigate();
  const color = "#fff";
  const override = {
    display: " block",
    margin: "0 auto",
  };
  useEffect(() => {
    // const interval = setInterval(() => {
    if (window.innerWidth < 400) {
      setScreenWidth(true);
    } else {
      setScreenWidth(false);
    }
    // }, 10);

    // return () => clearInterval(interval);
  }, []);
  return (
    <>
      {screenWidth ? (
        <>
          {disabled ? (
            <>
              <Button
                mb="30px"
                type={type}
                disabled={disabled}
                startIcon={
                  <ClipLoader
                    color={color}
                    loading={disabled}
                    css={override}
                    size={15}
                  />
                }
                onClick={onClickTerm}
                className={`btn1 ${className}`}
                style={{
                  fontSize: fontSize,
                  borderRadius: borderRadius,
                  width: "100%",
                }}
              >
                {title}
              </Button>
            </>
          ) : (
            <>
              <Button
                mb="30px"
                disabled={disabled}
                type={type}
                startIcon={startIcon}
                onClick={onClickTerm}
                className={`btn ${className}`}
                style={{
                  fontSize: fontSize,
                  borderRadius: borderRadius,
                  width: "100%",
                }}
              >
                {title}
              </Button>
            </>
          )}
        </>
      ) : (
        <>
          {/* Large Screen  */}
          {disabled ? (
            <>
              <Button
                mb="30px"
                type={type}
                disabled={disabled}
                startIcon={
                  <ClipLoader
                    color={color}
                    loading={disabled}
                    css={override}
                    size={15}
                  />
                }
                onClick={onClickTerm}
                className="btn1"
                style={{
                  fontSize: fontSize,
                  borderRadius: borderRadius,
                  width: "50%",
                }}
              >
                {title}
              </Button>
            </>
          ) : (
            <>
              <Button
                mb="30px"
                disabled={disabled}
                type={type}
                startIcon={startIcon}
                onClick={onClickTerm}
                className="btn"
                style={{
                  fontSize: fontSize,
                  borderRadius: borderRadius,
                  width: "50%",
                }}
              >
                {title}
              </Button>
            </>
          )}
        </>
      )}
    </>
  );
};

export default Header;
